module.exports = __webpack_public_path__ + "files/d20e514433fc704cd57e221b18980a97.png";